import { render } from "./MemberListOverlayFrivillig.vue?vue&type=template&id=46a50a28"
import script from "./MemberListOverlayFrivillig.vue?vue&type=script&lang=js"
export * from "./MemberListOverlayFrivillig.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__